/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { BricoPlanitBanner, propConverter, formatPrice } from 'chemistry'
import { TranslateContext } from 'client/common/translator'
import { isBrico } from '../../../../common/utils'
import { getPriceProps } from '../../../common/price'

export const BricoPlanitBannerWrapper = ({ product, format, lang, isGuest, currentLocation, showPraxisPlusHint }) => {
  const t = useContext(TranslateContext)

  if (!product?.drive_in_price || !isBrico(format)) {
    return <></>
  }

  const { price, priceProps } = getPriceProps(product, lang, format, isGuest, currentLocation, showPraxisPlusHint, t)
  const { oldUnitPrice, oldPrice, unitPrice, packetText, units, unitsInPacket } = propConverter({
    ...priceProps,
    isFeatured: true
  })

  const { drive_in_price, packagePriceFirst } = product

  const isPackagePriceFirst = packagePriceFirst !== false

  // unit price first
  let crossedPrice = oldUnitPrice || oldPrice
  let bigPrice = unitPrice || price || crossedPrice
  let priceAdditionalInfo = `${packetText} `
  let unitsStr = units
  let additionalInfoPrice = drive_in_price

  if (!unitPrice) unitsStr = undefined

  // package price first
  if (isPackagePriceFirst) {
    crossedPrice = oldPrice
    bigPrice = price || crossedPrice
    priceAdditionalInfo = `${units} `
    unitsStr = null
    additionalInfoPrice = (drive_in_price * (unitPrice || oldUnitPrice)) / bigPrice
  }

  const imgUrl = 'https://' + process.env.BRICO_ASSETS_HOST + '/basket/images/brico-planit.png'
  const campaignParms = 'int_campaign=pdp_planit_exclusive_pdp_banner&int_medium=pdp_planit_banner&int_source=pdp'
  const linkUrl =
    lang === 'fr' ? `/fr/brico-planit-magasins?${campaignParms}` : `/nl/brico-planit-winkels?${campaignParms}`

  return (
    <BricoPlanitBanner
      price={isPackagePriceFirst ? drive_in_price : drive_in_price / unitsInPacket}
      units={unitsStr}
      additionalInfoPrice={formatPrice(additionalInfoPrice)}
      imgUrl={imgUrl}
      linkUrl={linkUrl}
      linkText={t('drive_in_find_store_around_you')}
      title={t('drive_in_exclusive_price')}
      desc={<p dangerouslySetInnerHTML={{ __html: t('drive_in_info_lower_price') }}></p>}
      additionalInfoText={priceAdditionalInfo}
    />
  )
}
